// React core
import React, { useEffect } from "react";

// Third-party libraries
import {
  Briefcase,
  Calendar,
  CheckCircle,
  FileText,
  Globe,
  Mail,
  Phone,
  Star,
} from "react-feather";

// App imports
import useAppStore from "../store/AppStore.js";
import { useBoundStore } from "../store/UseBoundStore1.js";

// Assets and styles
import "../styles/ThankYou.css";
const ThankYou = () => {
  const { socket } = useAppStore();
  const {
    firstName,
    organizationName,
    jobTitle,
    organizationContactEmail,
    organizationContactNumber,
    organizationContactCountryCode,
  } = useBoundStore();

  useEffect(() => {
    socket?.close();
  }, [socket]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-white px-4">
      <div className="bg-white rounded-xl shadow-lg p-8 w-full max-w-xl text-center">
        {/* Top Badge */}
        <div className="flex justify-center mb-4">
          <div className="bg-purple-100 p-4 rounded-full">
            <CheckCircle className="text-purple-600" />
          </div>
        </div>

        {/* Heading */}
        <h1 className="text-2xl font-semibold text-center bg-gradient-to-r from-[#4776e6] to-[#8E54E9] text-transparent bg-clip-text mb-2">
          Thank You for Your Time
          {firstName && firstName !== "" ? `, ${firstName}!` : ""}
        </h1>

        <p className="text-app-text text-sm">
          We look forward to reviewing your candidacy further.
        </p>

        {/* Interview Summary */}
        <div className="bg-gradient-to-b from-[#f5f7ff] to-[#fafbff] border border-[#dce3fd] rounded-lg p-4 mt-6 space-y-5">
          <p className="flex items-center text-app-primary text-[15px] font-semibold">
            <FileText className=" mr-2 " size={16} /> Interview Summary
          </p>
          <div className="grid grid-cols-1  md:grid-cols-2 gap-y-2 text-sm text-app-text">
            <div className="flex justify-start items-center gap-x-1 text-[13px]">
              <Calendar className=" text-app-primary" size={13} />
              <p className="text-gray-500 font-normal ">Date:</p>
              <p className="text-app-text1 text-xs font-medium">
                {new Date().toDateString()}
              </p>
            </div>
            <div className="flex justify-start items-center gap-x-1 text-[13px]">
              <Briefcase className=" text-app-primary" size={13} />
              <p className="text-gray-500 font-normal">Position:</p>
              <p className="text-app-text1 text-xs font-medium">{jobTitle}</p>
            </div>
            <div className="flex justify-start items-center gap-x-1 text-[13px]">
              <Globe className=" text-app-primary" size={13} />
              <p className="text-gray-500 font-normal">Organization:</p>
              <p className="text-app-text1 text-xs font-medium">
                {organizationName}
              </p>
            </div>
          </div>
        </div>
        <div className="h-[1px] border-t w-full mt-5"></div>

        {/* Next Steps */}
        <div className="bg-purple-50 border border-purple-100 rounded-lg mt-6 p-4 text-left">
          <p className="flex items-center text-app-primary text-[15px] font-semibold mb-3">
            <Star className="mr-2" size={15} /> Next Steps
          </p>
          <p className="text-[13px] text-app-darkGrayText mb-2">
            We truly appreciate the time you spent with us today discussing your
            experience and qualifications.
          </p>
          <p className="text-[13px] text-app-darkGrayText mb-2">
            Our team will carefully review your interview and you can expect to
            hear back from us within{" "}
            <span className="text-[13px] font-semibold text-app-darkGrayText">
              3–5 business days
            </span>
            .
          </p>
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-x-4 gap-y-1 mt-5 text-sm text-purple-700">
            <div className="flex items-start gap-x-1 justify-center">
              <Mail size={13} className="mt-1" />{" "}
              <p className="text-[13px] ">{organizationContactEmail}</p>
            </div>
            <div className="flex items-start gap-x-1 justify-center">
              <Phone size={13} className="mt-1" />{" "}
              <p className="text-[13px] ">
                +{organizationContactCountryCode}-{organizationContactNumber}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankYou;
